module.exports = __webpack_public_path__ + "img/ios.0a2c30d6.jpg";